module.exports = __webpack_public_path__ + "static/cabina-conductor---tablero-de-control-e65aa804b38d8191baabcd8889d881fa.jpg";